import axios from 'axios';
import { CommonService } from './common.services';
export class TurnosService extends CommonService {
    async findCategoriasPadreBy(evento) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findCategoriasPadreBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findCategoriaBy(evento, categoria) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findCategoriaBy?evento=' + evento + '&categoria=' + categoria, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findCategoriasBy(evento, categoriaPadre) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findCategoriasBy?evento=' + evento + '&categoriaPadre=' + categoriaPadre, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findTurnosDisponiblesBy(evento) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findTurnosDisponiblesBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findTurnosDisponiblesByCategoria(evento, categoria) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findTurnosDisponiblesByCategoria?evento=' + evento + '&categoria=' + categoria, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findFranjasDisponiblesBy(evento, turnoDisponible) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findFranjasDisponiblesBy?evento=' + evento + '&turnoDisponible=' + turnoDisponible, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findAllFranjasBy(evento, turnoDisponible) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findAllFranjasBy?evento=' + evento + '&turnoDisponible=' + turnoDisponible, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async asignarTurnoConDescripcion(evento, franjaDisponible, acreditado, descripcionFranja) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/asignarTurnoConDescripcion?evento=' + evento + '&franjaDisponible=' + franjaDisponible + "&acreditado=" + acreditado.id + "&descripcionFranja=" + encodeURIComponent(descripcionFranja), { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async asignarTurnosCategorias(evento, acreditado, turnos, cancelarTomados, verificarAcreditado) {
        try {
            let paramTurnos = '';
            for (var i = 0; i < turnos.length; i++) {
                paramTurnos += "&turnosSeleccionados=" + turnos[i];
            }
            const response = await axios.get(super.getServerUrl() + '/mobile/asignarTurnosCategorias?evento=' + evento + '&acreditado=' + acreditado.id + "&cancelarTomados=" + cancelarTomados + "&verificarAcreditado=" + verificarAcreditado + paramTurnos, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async asignarTurno(evento, franjaDisponible, acreditado) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/asignarTurno?evento=' + evento + '&franjaDisponible=' + franjaDisponible + "&acreditado=" + acreditado.id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async cancelarTurno(evento, franjaDisponible, acreditado) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/cancelarTurno?evento=' + evento + '&franjaDisponible=' + franjaDisponible + "&acreditado=" + acreditado.id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findTurnosTomadosBy(evento, acreditado) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findTurnosTomadosBy?evento=' + evento + '&acreditado=' + acreditado.id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findTurnoTomadosBy(evento, id) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findTurnoTomadosBy?evento=' + evento + '&id=' + id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
}
